import { useState } from "react"

import { twMerge } from "tailwind-merge"

type CurrencyInputProps = {
  name: string
  defaultValue?: number
  className?: string
  onValueChange?: (value: number) => void
}

export function CurrencyInput({ name, defaultValue = 0, className = "", onValueChange }: CurrencyInputProps) {
  const [rawValue, setRawValue] = useState(defaultValue.toFixed(2))
  const [parsedValue, setParsedValue] = useState(defaultValue)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value

    if (raw === "" || /^\d*\.?\d{0,2}$/.test(raw)) {
      setRawValue(raw)

      const parsed = parseFloat(raw || "0") || 0
      setParsedValue(parsed)

      onValueChange?.(parsed)
    }
  }

  return (
    <div className={twMerge("relative w-full max-w-[10ch]", className)}>
      <span className="pointer-events-none absolute top-1 left-2 text-sm text-gray-500">$</span>
      <input
        type="text"
        inputMode="decimal"
        pattern="^\d*(\.\d{0,2})?$"
        placeholder="0.00"
        className="w-full rounded-md border border-gray-300 p-1 pr-1 pl-5 text-right text-sm"
        value={rawValue}
        onChange={handleChange}
      />
      <input type="hidden" name={name} value={parsedValue} />
    </div>
  )
}
